export var SegmentSource = /*#__PURE__*/function (SegmentSource) {
  SegmentSource["STANDARD"] = "standard";
  SegmentSource["INLINE"] = "inline";
  SegmentSource["ADHOC"] = "adhoc";
  SegmentSource["API_INLINE"] = "api-inline";
  return SegmentSource;
}({});